import * as React from "react";
import { useParams } from "react-router-dom";
import { HeaderElements } from "./HeaderElements/HeaderElements";
import Grid from "./Grid";
var Page = function (_a) {
  var canIndex = _a.canIndex,
    title = _a.title,
    description = _a.description;
  var page = useParams().page;
  var pageNumber = parseInt(page, 10);
  console.log(page);
  console.log(pageNumber);
  // Optional: Umleiten bei ungültigem Parameter
  if (isNaN(pageNumber)) {
    pageNumber = 1;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderElements, {
    canIndex: canIndex,
    title: title,
    description: description
  }), /*#__PURE__*/React.createElement(Grid, {
    page: pageNumber
  }));
};
export default Page;